// API Service
import apiService from "../../../../../services/api";
import { TopUpPaymentResponse } from "../model/topup.types";

export const createTopUpPayment = async (
    amountUsd: number
): Promise<TopUpPaymentResponse> => {
    const queryParams = new URLSearchParams({
        amount_usd: String(amountUsd),
    });

    const response = await apiService.post(
        `/webhooks/stripe/create-topup-payment?${queryParams.toString()}`
    );
    return response.data;
};
